<script>
  export let autocomplete = "";
  export let error = "";
  export let label;
  export let name = "input";
  export let placeholder = "";
  export let type = "text";
  export let value = "";

  /**
   * Bind values, casting number input values
   * to a number
   *
   * @param {Event} event
   */
  function handleInput(event) {
    value = /^(number|range)$/.test(type)
      ? Number(event.target.value)
      : event.target.value;
  }
</script>

<style>
  .form-field {
    margin: 0 0 1.6rem;
  }

  label {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }

  input {
    appearance: none;
    border: 1px solid var(--thin-shadow);
    border-radius: 0.25rem;
    display: block;
    font-size: 1.6rem;
    height: 100%;
    line-height: 1.25;
    margin: 0;
    padding: 1.35rem 1.6rem;
    text-align: left;
    width: 100%;
  }

  .error {
    color: var(--error-color);
    font-size: 1.4rem;
    margin: 0 0 1.6rem;
  }
</style>

<div class="form-field">
  {#if label}
    <label for={name}>{label}</label>
  {/if}
  <input
    autocomplete={autocomplete || name}
    id={name}
    {name}
    {placeholder}
    {type}
    {value}
    on:input={handleInput}
  />
  {#if error}
    <div class="error">{error}</div>
  {/if}
</div>
